export default "__VITE_ASSET__BHBqhZbd__ 584w";